import { AlertCircle, RefreshCw } from 'lucide-react';
import { PlayerProfile } from '../PlayerProfile';
import { useUsername } from '../../services/usernameCache';
import type { RelationshipPlayer } from '../../types/relationships';
import { relationshipLabel } from '../../utils/relationships';

export const RelationshipIdentity = ({ player }: { player: RelationshipPlayer }) => {
  const currentName = useUsername(player.uuid);
  return <PlayerProfile uuid={player.uuid} name={currentName || player.name || undefined} showUuid={false} inline />;
};

export const RelationshipFamilies = ({ families }: { families: string[] }) => (
  <div className="flex flex-wrap gap-1.5">
    {[...new Set(families)].map((family) => <span key={family} className="badge badge-neutral">{relationshipLabel(family)}</span>)}
  </div>
);

export const RelationshipLoading = () => (
  <div role="status" className="space-y-3 py-4" aria-label="Loading relationships">
    <span className="sr-only">Loading relationships…</span>
    <div className="skeleton h-5 w-2/3" /><div className="skeleton h-16 w-full" /><div className="skeleton h-16 w-full" />
  </div>
);

export const RelationshipError = ({ error, onRefresh }: { error: Error; onRefresh: () => void }) => (
  <div className="alert alert-warning flex flex-wrap items-center gap-3" role="alert">
    <AlertCircle className="h-4 w-4 shrink-0" />
    <p className="text-sm flex-1 min-w-0">{error.message}</p>
    <button type="button" className="glass-button min-h-11" onClick={onRefresh}><RefreshCw className="h-4 w-4" /> Refresh analysis</button>
  </div>
);
